export const dashboard = {
  actionPlan: {
    action: {
      reminder: {
        title: "REMINDER",
      },
      task: {
        title: "TASK",
      },
      tip: {
        title: "TIP",
      },
    },
    containerHeading: "This Week's Action Plan",
    guidance: "If you do anything this week, make it this",
  },
  addYourOwn: {
    cta: "+ Add your own",
    modal: {
      add: "Add",
      cancel: "Cancel",
      options: {
        task: {
          label: "Task",
          description: "a discrete action to complete and check off a list",
          value: "task",
        },
        tip: {
          label: "Tip",
          description: "a piece of information to save and reference over time",
          value: "tip",
        },
      },
      placeholders: {
        task: "Add your Task, for example “begin Menpur stims,” here...",
        tip: "Add your Tip, for example “avoid caffeine,” here...",
      },
      title: "Would you like to add a Tip or a Task?",
    },
  },
  alerts: {
    onboarding: {
      cta: "Got it",
      description:
        "Every Wednesday, your Conceive care team will provide you with new tips and tasks tailored to your journey. To receive updated tasks, make sure to check off the ones you've completed or dismiss those that don't feel relevant. You can also add notes for the team or save items to revisit later.",
      title: "Welcome to your weekly action plan",
    },
    "refer-a-friend": {
      cta: "Copy referral link",
      description:
        "Gift your friends 10% off of their first month of Conceive and get 10% off a month when they become a paying member.",
      title: "Refer-a-friend: Give 10% off and get 10% off",
    },
    "trial-one-week-left": {
      cta: "Extend now →",
      description:
        "Your free {{partnerName}} x Conceive membership is ending on {{endDate}}. Extend your membership now to maintain access to your care team, community, dashboard, and 24/7 text support.",
      title: "Extend membership Now",
    },
    "trial-three-weeks-left": {
      cta: "Extend and save →",
      description:
        "Your free {{partnerName}} x Conceive membership is ending soon. Save {{discount}} on your first month if you extend today!",
      title: "Extend membership + Save {{discount}}",
    },
  },
  card: {
    menu: {
      headings: {
        reminder: "Reminder actions",
        task: "Task actions",
        tip: "Tip actions",
      },
      items: {
        reminder: {
          delete: "Delete reminder",
        },
        task: {
          complete: "Mark task complete",
          delete: "Delete task",
          save: "Save task for later",
          unsave: "Move task from “Later” to “This week”",
        },
        tip: {
          delete: "Delete tip",
          save: "Save tip for later",
          unsave: "Move tip from “Later” to “This week”",
        },
      },
    },
    cta: {
      finish: "Finish",
      undo: "Undo completion",
    },
  },
  checklist: {
    addNote: {
      label: "Task completed!",
      placeholder: "Share your notes here...",
      prompt: "Nice job! Any notes to share with the Conceive team?",
    },
    completed: "Amazing! All Done!",
    cta: "Complete",
    determined: {
      undo: "Mark not completed",
    },
    emptyMessage: {
      body: "You’ve completed all your tasks! Check back Wednesday for more! You’ve got this and we’ve got you! 💕",
      title: "You’re doing great",
    },
    initialMessage: {
      body: "Your coach is looking at the details of your journey so far and will recommend next steps soon. We’ll send you an email as soon as your recommendations are ready.",
      title: "🚧 Fertility plan in progress 🚧",
    },
    linkTextDefault: "Read more",
    onboardingMessage: {
      body: "Every Wednesday, you’ll have tips and tasks to review from your coach based on where you are in your journey. Check them off as you do them or dismiss them with feedback if they don’t feel relevant. You can also add a note for your coach or come back to it later.",
    },
    pending: {
      memberCreated: "Your Own",
      remove: "Remove",
    },
    removed: {
      cta: {
        empty: "Not now",
        filled: "Send",
      },
      placeholder: "Share feedback here...",
      reminder: {
        label: "Reminder removed",
        prompt:
          "Do you have any feedback on that reminder you’d like to share with us? We’ll use it to personalize your plan!",
      },
      task: {
        label: "Task removed",
        prompt:
          "Do you have any feedback on that task you’d like to share with us? We’ll use it to personalize your plan!",
      },
      tip: {
        label: "Tip removed",
        prompt:
          "Do you have any feedback on that tip you’d like to share with us? We’ll use it to personalize your plan!",
      },
    },
    title: "Your action plan",
  },
  completedItems: {
    emptyMessage: {
      description: "Click to mark a task as complete",
      heading: "No completed tasks yet",
    },
    toggle: {
      hide: "Hide completed tasks",
      show: "Show completed tasks",
    },
  },
  designFlourish: { alt: "Design flourish" },
  empty: {
    description: "You've completed everything for this week!",
  },
  extend: {
    modal: {
      cta: "Got it",
      descriptions: {
        default: "",
        promo: "You'll see it reflected in your first bill",
      },
      headings: {
        default: "Your membership has been extended!",
        promo:
          "Your membership has been extended + your discount has been applied!",
      },
    },
  },
  plusUpsell: {
    alt: "Drawing of a hand holding a flower shaped link a heart",
    cta: "Upgrade Now",
    description:
      "Regain your clarity and confidence with our outcome-oriented program that helps us get results, together.",
    heading: "An action plan, designed for you",
    learnMore: "Learn More",
    modal: {
      alt: "Drawing of 2 hands holding one another with a purple background",
      closings: [
        "We’re working to match you with a community of peers and will be in touch soon! In the meantime, keep using your dashboard and message your care team with any questions.",
        "We’re so glad to have you as a Premium member!",
      ],
      cta: "Got it",
      description:
        "You’ve successfully upgraded! As part of your new membership you’ll get:",
      heading: "Welcome to Conceive Premium!",
      listItems: [
        "A care team made up of nurses and peer coaches, who you can call, video chat, or message anytime.",
        "A curated community of peers at a similar stage in their journey, to meet and message with.",
        "Exclusive community sessions with top providers in the industry—from REIs to doctors of Eastern medicine.",
        "A personalized care plan to take to your medical team.",
        "1:1 financial coaching.",
        "Early access to new products and discounts.",
      ],
    },
  },
  resubscribe: {
    modal: {
      alt: "Drawing of 2 hands holding one another with a purple background",
      cta: "Got it",
      heading: "Welcome back to Conceive!",
      plus: {
        closings: ["We’re so glad to have you back as a Conceive member!"],
        description:
          "You’ve successfully resubscribed! As part of your Plus membership you’ll get:",
        listItems: [
          "24/7 access to one-on-one coaching.",
          "Weekly evidence-based tips on your dashboard and recommended reading with the latest research in skimmable, bite-sized pieces.",
          "Exclusive access to community events on the latest topics.",
        ],
      },
      premium: {
        closings: [
          "We’re working to match you with a coach and crew and will be in touch soon! In the meantime, keep using your action plan and message your coach with any questions.",
          "We’re so glad to have you back as a Conceive member!",
        ],
        description:
          "You’ve successfully resubscribed! As part of your Premium membership you’ll get:",
        listItems: [
          "A dedicated coach and RN, who you can call, video chat, or message anytime.",
          "A crew of up to 10 peers at a similar stage in their journey, to meet and message with.",
          "Exclusive virtual sessions with top providers in the industry — from REIs to doctors of Eastern medicine.",
          "A personalized plan to take to your medical team.",
          "1:1 financial coaching.",
        ],
      },
    },
  },
  savedRecommendations: {
    headings: {
      task: "Tasks for later",
      tip: "Saved tips",
    },
    expansion: {
      task: {
        collapse: "See fewer saved tasks",
        expand: "See all saved tasks",
      },
      tip: {
        collapse: "See fewer saved tips",
        expand: "See all saved tips",
      },
    },
    emptyMessages: {
      task: {
        description: "Click to save any tasks you’d like to come back to",
        heading: "No Tasks for later",
      },
      tip: {
        description: "Click to keep the tips you’d like to remember",
        heading: "No saved Tips yet!",
      },
    },
  },
  upcomingEvents: {
    heading: "Your Upcoming Events",
  },
  welcome: {
    back: {
      anonymous: "Welcome back.",
      named: "Welcome back, {{firstName}}",
    },
    firstTime: {
      anonymous: "Welcome.",
      named: "Welcome, {{firstName}}",
    },
  },
};
